import React, {ReactElement} from "react";
import {Spin} from "antd";
import "./Spinner.scss";
import {SpinSize} from "antd/lib/spin";
import {TranslateFunction} from "react-localize-redux";
import {useSelector} from "react-redux";
import {selectTranslate} from "../../../store/selectors/translate";

interface Props {
    delay?: number
    size?: SpinSize
}

const Spinner: React.FC<Props> = ({size, delay}: Props): ReactElement => {
    const translatePath: string = "components.common.Spinner";
    const translate: TranslateFunction = useSelector(selectTranslate);

    return (
        <Spin
            wrapperClassName="df-spin-wrapper"
            size={size}
            spinning
            delay={delay}
            tip={translate(`${translatePath}.loading.text`) as string}
        >
            <div/>
        </Spin>
    );
};

export default Spinner;

Spinner.defaultProps = {
    delay: 300,
    size: "large",
};
